import type { ArticleData } from '@atlassian/jira-servicedesk-knowledge-services/src/services/rest/articles/index.tsx';
import type { CategoryId } from '@atlassian/jira-servicedesk-knowledge-services/src/types';

export const BROWSE_KNOWLEDGE_SUCCESS =
	'state.actions.browse-knowledge-success.BROWSE_KNOWLEDGE_SUCCESS' as const;

export type BrowseKnowledgeSuccessPayload = {
	id: CategoryId;
	results: ArticleData[];
	totalSize: number;
	start: number;
	limit: number;
	size: number;
	page: number;
	nextCursor?: string;
	prevCursor?: string;
	categoriesSupported: boolean;
};

export type BrowseKnowledgeSuccessAction = {
	type: typeof BROWSE_KNOWLEDGE_SUCCESS;
	payload: BrowseKnowledgeSuccessPayload;
};

export const browseKnowledgeSuccess = (
	payload: BrowseKnowledgeSuccessPayload,
): BrowseKnowledgeSuccessAction => ({
	type: BROWSE_KNOWLEDGE_SUCCESS,
	payload,
});
